module.exports = __webpack_public_path__ + "img/8.cf2c9c60.jpg";